var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('layout-header'),_c('layout-footer'),_c('layout-body')],1)}
var staticRenderFns = []

export { render, staticRenderFns }